import type { ThunkDispatch, UnknownAction } from "@reduxjs/toolkit";
import { useDispatch, useSelector, type TypedUseSelectorHook } from "react-redux";
import type { RequestsState } from "./requests.slice";

/** See @vv/teams-frontend/src/state/hooks.ts for why this is deliberately
 * local/narrow rather than importing @vv/state's RootState. */
interface RequestsModuleState {
  requests: RequestsState;
}

type RequestsModuleDispatch = ThunkDispatch<RequestsModuleState, unknown, UnknownAction>;

export const useRequestsDispatch = () => useDispatch<RequestsModuleDispatch>();
export const useRequestsSelector: TypedUseSelectorHook<RequestsModuleState> = useSelector;
